import React, { Component } from 'react'
import MaskedInput from 'react-text-mask'
import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import Payment from 'payment'
import { Icon } from '@yapay/design-system'
import svgSprite from 'static/img/icons.svg'
import cardMini from 'static/img/card-mini.svg'
import 'static/css/InputCreditCard.css'

export const generateRegexRange = (start, end) => {
  const orRegex = '|'
  let regexResult = ''

  start = parseInt(start, 10)
  end = parseInt(end, 10)

  if (!(start >= 0 && end > 0)) {
    return false
  }

  for (let i = start; i <= end; i++) {
    regexResult += '(' + i + ')'

    if (i < end) {
      regexResult += orRegex
    }
  }

  return regexResult
}

const getEloPattern = () => {
  let regexPattern = '^(' + generateRegexRange(457631, 457632) + '|'

  regexPattern += generateRegexRange(506699, 506778) + '|'
  regexPattern += generateRegexRange(509000, 509999) + '|'
  regexPattern += generateRegexRange(650031, 650033) + '|'
  regexPattern += generateRegexRange(650035, 650051) + '|'
  regexPattern += generateRegexRange(650405, 650439) + '|'
  regexPattern += generateRegexRange(650485, 650538) + '|'
  regexPattern += generateRegexRange(650541, 650598) + '|'
  regexPattern += generateRegexRange(650700, 650718) + '|'
  regexPattern += generateRegexRange(650720, 650727) + '|'
  regexPattern += generateRegexRange(650901, 650978) + '|'
  regexPattern += generateRegexRange(651652, 651679) + '|'
  regexPattern += generateRegexRange(655000, 655019) + '|'
  regexPattern += generateRegexRange(655021, 655058) + ')'

  return new RegExp(regexPattern)
}

class InputCreditCard extends Component {
  state = {
    value: '',
    issuer: 'none',
    showErrorMessage: false,
    stopChangingIssuer: false,
  }

  updateCards = () => {
    var rules = this.getRules()
    for (var i = rules.length - 1; i >= 0; i--) {
      Payment.getCardArray().unshift(rules[i])
    }
  }

  getRules = () => {
    return [
      {
        cvcLength: [3],
        pattern: /^((((457393)|(431274)|(627780)|(636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})$/,
        format: /(\d{1,4})/g,
        length: [16],
        luhn: true,
        type: 'elo',
      },
      {
        cvcLength: [3],
        pattern: getEloPattern(),
        format: /(\d{1,4})/g,
        length: [16],
        luhn: true,
        type: 'elo',
      },
      {
        cvcLength: [3],
        pattern: /^(4011(78|79)|43(1274|8935)|45(1416|7393|763(1|2))|50(4175|6699|67[0-7][0-9]|9000)|50(9[0-9][0-9][0-9])|627780|63(6297|6368)|650(03([^4])|04([0-9])|05(0|1)|05([7-9])|06([0-9])|07([0-9])|08([0-9])|4([0-3][0-9]|8[5-9]|9[0-9])|5([0-9][0-9]|3[0-8])|9([0-6][0-9]|7[0-8])|7([0-2][0-9])|541|700|720|727|901)|65165([2-9])|6516([6-7][0-9])|65500([0-9])|6550([0-5][0-9])|655021|65505([6-7])|6516([8-9][0-9])|65170([0-4]))$/,
        format: /(\d{1,4})/g,
        length: [16],
        luhn: true,
        type: 'elo',
      },
      {
        cvcLength: [3],
        pattern: /^(606282\d{10}(\d{3})?)|^(3841\d{15})$/,
        format: /(\d{1,4})/g,
        length: [13, 16, 19],
        luhn: true,
        type: 'hipercard',
      },
      {
        cvcLength: [3],
        pattern: /^50[0-9]{17}$/,
        format: /(\d{1,4})/g,
        length: [16, 19],
        luhn: true,
        type: 'aura',
      },
      {
        cvcLength: [3, 4],
        pattern: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
        format: /(\d{1,4})/g,
        length: [16],
        luhn: true,
        type: 'discover',
      },
      {
        cvcLength: [3, 4],
        pattern: /^3[47][0-9]{13}$/,
        format: /(\d{1,4})/g,
        length: [15],
        luhn: true,
        type: 'amex',
      },
      {
        cvcLength: [3, 4],
        pattern: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
        format: /(\d{1,4})/g,
        length: [14, 16],
        luhn: true,
        type: 'dinersclub',
      },
      {
        cvcLength: [3],
        pattern: /^(5(018|0[23]|[68])|6(39|7))/,
        format: /(\d{1,4})/g,
        length: [12, 13, 14, 15, 16, 17, 18, 19],
        luhn: true,
        type: 'maestro',
      },
      {
        cvcLength: [3],
        pattern: /^((5[1-5][0-9]{14})$|^(2(2(?=([2-9]{1}[1-9]{1}))|7(?=[0-2]{1}0)|[3-6](?=[0-9])))[0-9]{14})$/,
        format: /(\d{1,4})/g,
        length: [16],
        luhn: true,
        type: 'mastercard',
      },
      {
        cvcLength: [3],
        pattern: /^4(026|17500|405|508|844|91[37])/,
        format: /(\d{1,4})/g,
        length: [16],
        luhn: true,
        type: 'visaelectron',
      },
      {
        cvcLength: [3],
        pattern: /^4[0-9]{12}(?:[0-9]{3})?$/,
        format: /(\d{1,4})/g,
        length: [13, 16],
        luhn: true,
        type: 'visa',
      },
      {
        cvcLength: [3],
        pattern: /^(637095)\d{0,10}$/,
        format: /(\d{1,4})/g,
        length: [16],
        luhn: false,
        type: 'hiper',
      },
    ]
  }

  handleChange = event => {
    const creditCardValid = Payment.fns.validateCardNumber(event.target.value)

    if (!this.state.stopChangingIssuer) {
      this.setState({ issuer: Payment.fns.cardType(event.target.value) })
    }

    this.setState({ value: event.target.value })
    this.checkFilled(event.target.value)
    this.checkValid(creditCardValid)
    this.checkErrorMessage(creditCardValid)
    if (this.props.onChange) this.props.onChange(event)
  }

  handleBlur = event => {
    const creditCardValid = Payment.fns.validateCardNumber(event.target.value)

    this.checkValid(creditCardValid)
    this.checkErrorMessage(creditCardValid)

    if (this.props.onBlur) this.props.onBlur(this.state.issuer)
  }

  handleFocus = event => {
    if (this.props.onFocus) this.props.onFocus(event)
  }

  handleClick = card => {
    this.setState({
      issuer: card,
      stopChangingIssuer: true,
    })
    if (this.props.onClick) this.props.onClick(card)
  }

  checkFilled = value => {
    if (value) this.setState({ isFilled: true })
    else this.setState({ isFilled: false })
  }

  checkValid = valid => {
    if (valid) this.setState({ isValid: true })
    else this.setState({ isValid: false })
  }

  checkErrorMessage = valid => {
    this.setState({ showErrorMessage: !valid })
  }

  componentDidMount() {
    this.updateCards()
  }

  render() {
    const wrapperClass = ClassNames(
      'input',
      {
        'input--small': this.props.size === 'small',
        'input--shadow': this.props.withShadow === true,
      },
      this.props.className ? this.props.className.split(' ') : '',
    )
    const inputClass = ClassNames('input__field', {
      'input__field--filled': this.state.isFilled,
      'input__field--success': this.state.isValid === true,
      'input__field--error': this.state.isValid === false,
    })

    let mask
    const { issuer } = this.state

    if (issuer === 'amex') {
      mask = [
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        ' ',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        ' ',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
      ]
    } else if (issuer === 'dinersclub') {
      mask = [
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        ' ',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        ' ',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
      ]
    } else if (['hipercard', 'mastercard', 'visa'].includes(issuer)) {
      mask = [
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        ' ',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        ' ',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        ' ',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
      ]
    } else {
      mask = [
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        ' ',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        ' ',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        ' ',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
      ]
    }

    return (
      <div className={wrapperClass}>
        <MaskedInput
          mask={mask}
          type="tel"
          id="cardNumber"
          value={this.state.value}
          name={this.props.name}
          disabled={this.props.disabled}
          maxLength={this.props.maxLength}
          className={inputClass}
          autoComplete="off"
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          required={this.props.required}
        />
        <label className="input__label" htmlFor={this.props.id}>
          {this.props.label}
        </label>

        {this.state.showErrorMessage ? (
          <p className="input__error-message">Cartão inválido</p>
        ) : (
          <p className="input__error-message" />
        )}

        <ul className="input-cc-expanded">
          {this.props.clickToPayIcons && (
            <li>
              <img src={cardMini} alt="Card Mini" width="35" height="26" />
            </li>
          )}
          {this.props.availableCC.map(card => (
            <li key={card}>
              <Icon
                icon={
                  this.props.clickToPayIcons
                    ? `cc-${card}-click-to-pay`
                    : `cc-${card}`
                }
                width="35"
                height="26"
                className={this.state.issuer === card ? 'active' : ''}
                onClick={() => this.handleClick(card)}
                url={svgSprite}
              />
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

InputCreditCard.propTypes = {
  /** Classe adicional para o wrapper */
  className: PropTypes.string,
  /** Atributo value do input, caso precise vir pré-definido */
  value: PropTypes.string,
  /** ID do input para servir como `for` do label */
  id: PropTypes.string.isRequired,
  /** Label que referencia o input */
  label: PropTypes.string.isRequired,
  /** Callback para quando modificar o value do input */
  onChange: PropTypes.func,
  /** Callback para quando o focus sair do input */
  onBlur: PropTypes.func,
  /** Tamanho máximo de caracteres do input */
  maxLength: PropTypes.number,
  /** Atributo name do input */
  name: PropTypes.string,
  /** Atributo required do input */
  required: PropTypes.bool,
  /** Atributo disabled do input */
  disabled: PropTypes.bool,
  /** Array com as bandeiras de cartões disponíveis */
  availableCC: PropTypes.array.isRequired,
  /** click-to-pay icons */
  clickToPayIcons: PropTypes.bool,
}

export default InputCreditCard
